import { render } from "./CommonModal.vue?vue&type=template&id=1aad207d&scoped=true&ts=true"
import script from "./CommonModal.vue?vue&type=script&lang=ts"
export * from "./CommonModal.vue?vue&type=script&lang=ts"

import "./CommonModal.vue?vue&type=style&index=0&id=1aad207d&lang=stylus&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aad207d"]])

export default __exports__